(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/shared/error-messages.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/shared/error-messages.js');
"use strict";


const getMessageByCode = errorCode => {
  switch (Number(errorCode)) {
    case 10050:
      return 'Ange en giltig e-postadress';
    case 30014:
      return 'Ange en giltig e-postadress';
    case 20670:
      return 'Den angivna e-postadressen används på ett annat spelkonto. Ange en annan e-postadress eller kontakta Kundservice.';
    case 10056:
      return 'Den angivna e-postadressen används på ett annat spelkonto. Ange en annan e-postadress eller kontakta Kundservice.';
    case 12110:
      return 'Felaktigt mobiltelefonnummer, försök igen.';
    case 12111:
      return 'Det angivna mobilnumret används på ett annat spelkonto. Ange ett annat mobilnummer eller kontakta Kundservice.';
    case 12570:
      return 'Det angivna mobilnumret används på ett annat spelkonto. Ange ett annat mobilnummer eller kontakta Kundservice.';
    case 12120:
      return 'Felaktigt mobilnummer, försök igen.';
    case 30010:
      return 'Du har inte rätt behörighet för att beställa detta utdrag. För vissa typer krävs att du har loggat in med BankID.';
    case 30020:
      return 'Felaktigt värde inskickat för beställning. Beställd typ av utdrag finns ej.';
    case 30040:
      return 'Det finns redan ett beställt utdrag av denna typ som bearbetas eller är färdigt för nedladdning.';
    default:
      return null;
  }
};
svs.myProfile.react.shared.errorMessages = {
  getMessageByCode
};

 })(window);